export default {
    'menus':{
        'file':{
            'visible':false,
            'items':{
                'new':{
                    tag:'MenuFileNew'
                }
            }
        },
        // 'edit':{
        //     'visible':false
        // },
        'object':{
            'visible':false,
            'items':{
                'delete':{
                    tag:'ObjectDelete'
                },
                'group':{
                    tag:'ObjectGroup'
                },
                'ungroup':{
                    tag:'ObjectUnGroup'
                }
            }
        },
        // 'insert':{
        //     'visible':false
        // },
        // 'view':{
        //     'visible':false
        // },
        'workspace':{
            'visible':false,
            'items':{
                'snapToGrid':{
                    tag:'WorkspaceSnapToGrid'
                }
            }
        }//,
        // 'window':{
        //     'visible':false
        // },
        // 'help':{
        //     'visible':false
        // }
    },
    helperData:{}
}
